import { Component, Input } from '@angular/core';
import { PropertyDto } from '@usucampeao/interfaces';
import { CadastroContratoDto, OwnerDto, ProjetoCategoria, ProjetoTipo } from '@usucampeao/lib-reurb-simplificado';
import { TipoContract } from '../../enums';

@Component({
  selector: 'usucampeao-contratos-v3',
  templateUrl: './contratos-v3.component.html',
  styleUrls: ['./contratos-v3.component.scss']
})
export class ContratosV3Component {
  @Input() cadastro: CadastroContratoDto;
  @Input() proprietario: Partial<OwnerDto>;
  @Input() conjuge: Partial<OwnerDto>;
  @Input() imovel: Partial<PropertyDto>;
  @Input() tipo: TipoContract;
  @Input() isPrint: boolean;

  public get tiposContrato(): typeof TipoContract {
    return TipoContract;
  }

  public get tipoProjeto(): typeof ProjetoTipo {
    return ProjetoTipo;
  }

  public get projetoCategoria(): typeof ProjetoCategoria {
    return ProjetoCategoria;
  }

  public get isProcuracao(): boolean {
    return this.tipo === this.tiposContrato.PROCURACAO_AVERBACAO ||
      this.tipo === this.tiposContrato.PROCURACAO_REURB_AVERBACAO;
  }
}
